import styled from 'styled-components';
import { variables } from '../../../../styles/variables';

export const StudentSearchContainer = styled.div`
  .ant-select {
    border-radius: 6px;
    width: 24%;
    margin-bottom: 20px;
    font-size: 20px;
  }
  .ant-select div.ant-select-selector {
    border-radius: 6px;
  }
  .ant-select:not(.ant-select-disabled):hover,
  .ant-select:not(.ant-select-disabled):active,
  .ant-select:not(.ant-select-disabled):focus,
  .ant-select-focused,
  .ant-select-open {
    box-shadow: 0px 0px 3px 1px rgba(50, 50, 50, 0.2);
  }
  .ant-select-selection-placeholder {
    font-family: ${variables.fontText};
    font-size: 1.6rem;
  }
  h3 {
    color: ${variables.colorGrey};
    font-weight: 700;
    font-size: 2rem;
  }
  span.ant-select-arrow {
    color: ${variables.colorDecorator};
    top: 47%;
    svg {
      height: 1.5rem;
      width: 1.5rem;
    }
  }
  .ant-select-focused.ant-select-single:not(.ant-select-customize-input) .ant-select-selector,
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: ${variables.colorBorder};
  }

  @media (max-width: 1500px) {
    .ant-select {
      width: 36%;
    }
  }

  @media (max-width: 992px) {
    .ant-select {
      width: 48%;
    }
  }

  @media (max-width: 668px) {
    .ant-select {
      width: 64%;
    }
  }
`;

